export namespace BlinkingHighlight {
  export namespace Plugin {
    export const Name = 'blinking-highlight';
  }
}

// This is kept for backwards compatibility
export namespace BlinkingSquare {
  export namespace Plugin {
    export const Name = 'blinking-highlight';
  }
}
